import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNotify } from "@/contexts/NotifyContext";
import axios from "axios";
import { queryPresentionNames } from "@/services/EventService";
import { ConfirmationStatus } from "iasma-datatypes";
import { confirmationIcon } from "./ChartConfirmationNames";

type dataType = {
    name: string;
    confirmation: ConfirmationStatus;
    absensi: string;
}

export default function ChartPresentionNames({ eventId, year, callback }: {
    eventId: number;
    year: number;
    callback: () => void;
}) {
    const { setToken } = useAuth();
    const { setNotify } = useNotify();
    const [data, setData] = useState<dataType[]>([]);

    useEffect(() => {
        async function fetchNames() {
            setNotify(null);
            setToken(axios);
            let recs = await queryPresentionNames(eventId, Number(year)).then(
                (recs: any) => {
                    const result: dataType[] = recs.map((rec: any) => ({
                        name: rec.Name,
                        confirmation: rec.Confirmation,
                        absensi: rec.AttendanceTime ? rec.AttendanceDate +" "+ rec.AttendanceTime : "alun lai"
                    }));
                    setData(result);
                }, (error: any) => {
                    setNotify({ title: "Kehadiran Gagal", error, severity: 'error' });
                }
            );
        }
        fetchNames();
    }, [eventId, year]);

    return (
        <div className="mt-2 flex flex-col items-center justify-center">
            <h4 className="text-center font-bold">Kehadiran Angkatan {year}</h4>
            <div className="mt-6 w-full max-w-xl">
                <div className="max-h-[60vh] overflow-auto rounded-md border border-slate-200 bg-white">
                    <table className="w-full text-[11px]">
                        <thead className="bg-slate-100">
                            <tr>
                                <th className="px-3 py-2 text-left text-nowrap">Nama</th>
                                <th className="px-3 py-2 text-center">Konfirmasi Katibo</th>
                                <th className="px-3 py-2 text-right">Alah Tibo Jam</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((rec, i) => (
                                <tr key={i} className="border-t border-slate-200">
                                    <td className="px-0.5 py-1.5 text-left text-nowrap">{rec.name}</td>
                                    <td className="px-0.5 py-1.5 text-left flex justify-start">{confirmationIcon(rec.confirmation)}</td>
                                    <td className="px-0.5 py-1.5 text-right text-nowrap font-mono">{rec.absensi}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="mt-3 mx-2">
                    <button type="button" onClick={callback} className="w-full rounded-md bg-[#f8ad3c] p-2.5 text-white opacity-80 transition hover:opacity-100">
                        Kembali
                    </button>
                </div>
            </div>
        </div>
    );
}